import { ComponentType, ReactNode, useEffect } from 'react'
import { ParsedTab, useNewCMS } from './index.js'
import { Tabs } from '../Tabs/index.js'
import { AppHeader } from '../AppHeader/index.js'
import { colors } from '../../tokens/colors.js'
import { Stack } from '../Stack/index.js'

export function RootRedirect({ to }: { to: string }) {
  const cms = useNewCMS()

  useEffect(() => {
    cms.navigate(to, { replace: true })
  }, [to])

  return null
}

export type RootLayoutProps = {
  tabs: ParsedTab[]
  children: ReactNode
  leadComponent?: ReactNode
  trailComponent?: ReactNode
}

export function RootLayout({
  tabs,
  children,
  leadComponent,
  trailComponent,
}: RootLayoutProps) {
  const cms = useNewCMS()

  const realTabs: Tabs[] = tabs
    .filter((t) => t.id !== 'default')
    .map((tab) => {
      return {
        value: tab.abs,
        label: tab.title,
        icon: tab.icon,
      }
    })

  return (
    <Stack
      direction="column"
      justify="start"
      align="start"
      style={{
        overflow: 'hidden',
        position: 'relative',
        height: '100vh',
        width: '100%',
        background: colors.neutralInverted100,
      }}
    >
      <AppHeader>
        <AppHeader.Left>
          {leadComponent}

          <Tabs
            tabs={realTabs}
            value={'/' + cms.location.split('/').filter(Boolean)[0]}
            onChange={cms.navigate}
          />
        </AppHeader.Left>

        <AppHeader.Right>{trailComponent}</AppHeader.Right>
      </AppHeader>

      {children}
    </Stack>
  )
}
